import React, { useState, useEffect, useRef } from "react";

const CustomLinesEllipsis = ({ text, maxLines }) => {
    const [clampedText, setClampedText] = useState(text);
    const textRef = useRef(null);

    useEffect(() => {
        const measureText = () => {
            if (textRef.current) {
                const lineHeight = parseFloat(getComputedStyle(textRef.current).lineHeight);
                const maxHeight = lineHeight * maxLines;
                let words = text?text.split(" "):[''];

                let truncatedText = "";
                textRef.current.innerText = text;

                while (textRef.current.scrollHeight > maxHeight && words.length > 1) {
                    words.pop();
                    truncatedText = words.join(" ") + "...";
                    textRef.current.innerText = truncatedText;
                }

                setClampedText(truncatedText || text);
            }
        };

        measureText();
        window.addEventListener("resize", measureText);
        return () => window.removeEventListener("resize", measureText);
    }, [text, maxLines]);

    return (
        <div ref={textRef} style={{ display: "-webkit-box", WebkitLineClamp: maxLines, WebkitBoxOrient: "vertical", overflow: "hidden" }}>
            {clampedText}
        </div>
    );
};

export default CustomLinesEllipsis;
